module.exports = __webpack_public_path__ + "img/home2.3131b183.png";